import { currencies } from 'country-data';
import _ from 'lodash';
import numeral from 'numeral';
import { Dropdown } from 'semantic-ui-react';

const DYZIO_ENABLED_CURRENCIES_ALL = _.map(currencies.all, 'code');

const DYZIO_ENABLED_CURRENCIES_DEFAULTS = ['GBP', 'USD', 'EUR', 'divider'];

const DYZIO_ENABLED_CURRENCIES_NON_DEFAULTS = _.reject(DYZIO_ENABLED_CURRENCIES_ALL, code => (
  code === 'GBP' || code === 'USD' || code === 'EUR'));

const DYZIO_ENABLED_CURRENCIES = _.concat(DYZIO_ENABLED_CURRENCIES_DEFAULTS, DYZIO_ENABLED_CURRENCIES_NON_DEFAULTS);


const generateDyzioCurrencies = () => _.map(DYZIO_ENABLED_CURRENCIES, currencyCode => {
  const currency = _.find(currencies.all, ['code', currencyCode]);
  if (currencyCode === 'divider') {
    return { component: Dropdown.Divider };
  }
  return {
    key: currency.code,
    text: `${currency.symbol} - ${currency.name} (${currency.code})`,
    value: currency.code,
  };
});

export const DYZIO_CURRENCIES = generateDyzioCurrencies();

export const CURRENCY_GBP = 'GBP';
export const CURRENCY_EUR = 'EUR';
export const CURRENCY_USD = 'USD';

export const renderCurrencySymbol = currencyCode => {
  const currency = _.find(currencies.all, ['code', currencyCode]);
  return currency ? currency.symbol : '';
};

const cf = num => numeral(num).format('0,0');

export const renderCurrencyQuantity = ({ currency, amount }) =>
  `${renderCurrencySymbol(currency)} ${cf(amount)}`;



/** WEBPACK FOOTER **
 ** ./src/utils/helpers/currencies.js
 **/